// src/components/pages/backtest/partials/DataPeriodAlert.js

import React from "react";
// i18n 처리를 위해 useTranslation이 필요할 경우 추가합니다.
// 하지만 현재 컴포넌트에서는 부모로부터 t 함수를 props로 받고 있으므로,
// DataPeriodAlert 자체에 useTranslation을 추가하지 않아도 됩니다. 

// 💡 기간 제약 알림 컴포넌트
// DataPeriodAlert 컴포넌트는 부모 컴포넌트에서 t 함수와 dataPeriodInfo를 props로 받습니다.
const DataPeriodAlert = ({ dataPeriodInfo, t }) => {
    // 필요한 데이터 구조를 비구조화 할당(Destructuring)합니다.
    const { limitingSymbolsInfo } = dataPeriodInfo;
    
    // 데이터가 없거나 제한된 종목이 없으면 렌더링하지 않습니다.
    if (!limitingSymbolsInfo || limitingSymbolsInfo.length === 0) {
        return null;
    }

    // 1. 제한된 종목 이름 추출 (예: "BRK-A, QQQ")
    const limitingSymbolsString = limitingSymbolsInfo
        .map(item => item.symbol)
        .join(', ');

    // 2. 세부 사항을 표시하기 위한 항목 리스트 (<ul><li> 태그 사용)
    const limitListDetails = limitingSymbolsInfo.map(item => (
        <li key={item.symbol} style={{ margin: '3px 0' }}>
            {item.symbol}: **{item.actualStart}**
        </li>
    ));

    return (
        <div style={{ 
            backgroundColor: '#fcf8e3', 
            borderLeft: '5px solid #f0ad4e', 
            padding: '15px', 
            marginBottom: '15px',
            borderRadius: '4px',
            color: '#8a6d3b',
            fontSize: '0.9rem'
        }}>
            {/* ⚠️ 경고 헤드라인 수정: 동적 문자열 사용 */}
            <p style={{ color: '#8a6d3b', fontWeight: 'bold', marginBottom: '10px' }}>
                ⚠️ {t("backtest.period_cut_warning_dynamic", { symbols: limitingSymbolsString })}
            </p>

            {/* 항목 리스트는 <p> 대신 <ul>을 사용하여 적절한 HTML 구조를 유지합니다. */}
            <ul style={{ listStyleType: 'disc', paddingLeft: '25px', margin: '0' }}>
                {limitListDetails}
            </ul>
        </div>
    );
};

export default DataPeriodAlert;